import moment from "moment-timezone";
import { formatFromTime  } from "../Utils/utils";


/**
 * Converts a schedule from New York time to the specified target time zone.
 *
 * @param {string} schedule - The input schedule string.
 * @param {string} targetTimeZone - The time zone to convert the schedule to (e.g., 'America/Chicago', 'Europe/London').
 * @returns {string} - The converted schedule string in the target time zone.
 */
export const TimeUtils = (schedule, targetTimeZone) => {
  const timeZoneNY = 'America/New_York';

  return schedule
    ?.split('&&&')
    .filter(Boolean)
    .map((entry) => {
      const [day, startTime, endTime] = entry.split(' - ');

      const base = moment.tz(`${day} ${startTime}`, 'ddd HH:mm', timeZoneNY);
      const startTarget = base.clone().tz(targetTimeZone);
      const endTarget = moment.tz(`${day} ${endTime}`, 'ddd HH:mm', timeZoneNY).tz(targetTimeZone);


      // const startTarget = moment.tz(`${startTime}`, 'HH:mm', timeZoneNY).tz(targetTimeZone);
      // const endTarget = moment.tz(`${endTime}`, 'HH:mm', timeZoneNY).tz(targetTimeZone);

      const formattedStart = startTarget.format('HH:mm');
      const formattedEnd = endTarget.format('HH:mm');

          const updatedDay = startTarget.format('ddd').toUpperCase();


      const dayData = moment.tz(`${startTime}`, 'HH:mm', timeZoneNY).tz(targetTimeZone);

      return `${updatedDay} - ${formattedStart} - ${formattedEnd}`;
    })
    .join('\n') || ''; 
};

export const getUpdatedDateWithTimezone = (date, schedule, targetTimeZone) => {
  const timeZoneNY = 'America/New_York';

  if (!schedule) return '';

  const firstEntry = schedule.split('&&&').filter(Boolean)[0];

  if (!firstEntry) return '';

  const [day, startTime] = firstEntry.split(' - ');

  // Combine date with time (in NY timezone)
  const nyDateTime = moment.tz(`${date} ${startTime}`, 'YYYY-MM-DD HH:mm', timeZoneNY);

  // Convert to target timezone
  const converted = nyDateTime.clone().tz(targetTimeZone);

  // Return updated date in YYYY-MM-DD format
  return converted.format('MM/DD/YYYY');
};

export const normalTime = (start, end, timeZone) => {
    const targetTimeZone = 'America/New_York';
    var start = formatFromTime(start);
    var end = formatFromTime(end);
    console.log("targetTimeZone:", targetTimeZone);
    console.log("timeZone:", timeZone)

    const currentDate = moment().format('YYYY-MM-DD'); 

    const startTime = moment.tz(`${currentDate} ${start}`, 'YYYY-MM-DD HH:mm', timeZone).clone().tz(targetTimeZone).format('HH:mm');
    const endTime = moment.tz(`${currentDate} ${end}`, 'YYYY-MM-DD HH:mm', timeZone).clone().tz(targetTimeZone).format('HH:mm');

    return `${startTime} - ${endTime}`;
}

export const TimetoConvert = (start, end, timeZone) => {
    const sourceTimeZone = 'America/New_York';

    var start = formatFromTime(start);
    var end = formatFromTime(end);

    const currentDate = moment().format('YYYY-MM-DD');
    const startTimeInNY = moment.tz(`${currentDate} ${start}`, 'YYYY-MM-DD HH:mm', timeZone);
    const endTimeInNY = moment.tz(`${currentDate} ${end}`, 'YYYY-MM-DD HH:mm', timeZone);

    const startTimeConverted = startTimeInNY.tz(sourceTimeZone).format('HH:mm');
    const endTimeConverted = endTimeInNY.tz(sourceTimeZone).format('HH:mm');

    return `${startTimeConverted} - ${endTimeConverted}`;
}





